import { createSlice, PayloadAction } from "@reduxjs/toolkit";

interface User {
  mobile_number: string;
  first_name: string;
  last_name: string;
  points: number;
  role?: string;
}

interface Tokens {
  access: string;
  refresh: string;
}

interface LoginResponse {
  message: string;
  user: User;
  tokens: Tokens;
}

interface LoginState {
  user: User | null;
  tokens: Tokens | null;
  loading: boolean;
  error: string | null;
  isAuthenticated: boolean;
}

const initialState: LoginState = {
  user: null,
  tokens: null,
  loading: false,
  error: null,
  isAuthenticated: false,
};

const loginSlice = createSlice({
  name: "login",
  initialState,
  reducers: {
    loginStart: (state) => {
      state.loading = true;
      state.error = null;
    },
    loginSuccess: (state, action: PayloadAction<LoginResponse>) => {
      state.loading = false;
      state.user = action.payload.user;
      state.tokens = action.payload.tokens;
      state.isAuthenticated = true;
      state.error = null;
      
      // Store tokens in localStorage
      localStorage.setItem('accessToken', action.payload.tokens.access);
      localStorage.setItem('refreshToken', action.payload.tokens.refresh);
    },
    loginFailure: (state, action: PayloadAction<string>) => {
      state.loading = false;
      state.error = action.payload;
      state.isAuthenticated = false;
    },
    logout: (state) => {
      state.user = null;
      state.tokens = null;
      state.isAuthenticated = false;
      state.loading = false;
      state.error = null;
      
      // Clear tokens from localStorage
      localStorage.removeItem('accessToken');
      localStorage.removeItem('refreshToken');
    },
    clearError: (state) => {
      state.error = null;
    },
  },
});

export const { loginStart, loginSuccess, loginFailure, logout, clearError } = loginSlice.actions;
export default loginSlice.reducer;
